<template>
  <div class="settled-enterprise">
    <div class="settled-enterprise-col" v-for="(items, index) in listData" :key="index">
      <div class="time">{{index}}</div>
      <div class="enterprise-list">
        <div v-for="item in items" :key="item.coName">{{item.coName}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss" scoped>
.settled-enterprise {
  .settled-enterprise-col {
    display: flex;
    .time {
      width: 1.2rem;
      height: 0.22rem;
      padding-left: 0.1rem;
      box-sizing: border-box;
      color: #fff;
      font-size: 0.15rem;
      background: url("~@/assets/images/bigScreen/bg-sjx.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
    .enterprise-list {
      flex: 1;
      padding-left: 0.2rem;
      border-left: 0.01rem solid #CAE1FB;
      position: relative;
      > div{
        background: linear-gradient(to left, rgba(28,52,78,0.7), rgba(26,47,67,0.3));
        color: 0.2rem;
        font-size: 0.12rem;
        padding: 0.05rem 0.1rem;
        margin-bottom: 0.1rem;
        box-sizing: border-box;
        color: #E9F5FF;
      }
      &:before {
        left: -0.08rem;
        top: 0.03rem;
        position: absolute;
        display: block;
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        background: #CAE1FB;
        content: '';
      }
    }
  }
}
</style>